import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { TranslateService } from 'chomsky-ng2';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const VALID_LOCALES: string[] = ['de', 'en', 'en-GB', 'en-US', 'es', 'fr', 'it', 'jp', 'nl', 'ru', 'zh'];
const USER_LOCALE: string = VALID_LOCALES.indexOf(window.navigator.language) > -1 ? window.navigator.language : 'en-US';

export function main(): any {
    const chomskySubscription: any = TranslateService.use(USER_LOCALE).subscribe(() => {
        chomskySubscription.unsubscribe();
        platformBrowserDynamic()
            .bootstrapModule(AppModule)
            .catch(err => console.error(err)); // tslint:disable-line
    });
}

export function bootstrapDomReady(): any {
    document.addEventListener('DOMContentLoaded', main);
}

bootstrapDomReady();



// WEBPACK FOOTER //
// /home/jenkins/hydrogen/workspace/Release_Engineering/Artifactory-Release-Packagers/Builders/Conduit-Release/consent/src/main.ts